import React from "react";
import Skeleton from "react-loading-skeleton";

function BlogSkeleton() {
  return (
    <div className="flex lg:flex-row flex-col items-center justify-center lg:justify-between w-full  gap-4 mb-14">
      <Skeleton
        height={360}
        width={300}
        className="normal-radius  w-[80%] mx-auto"
        baseColor="#ccc"
      />
      <Skeleton
        height={360}
        width={300}
        className="normal-radius  w-[80%] mx-auto"
        baseColor="#ccc"
      />
      <Skeleton
        width={300}
        height={360}
        className="normal-radius  w-[80%] mx-auto"
        baseColor="#ccc"
      />
    </div>
  );
}

export default BlogSkeleton;
